// @ts-nocheck
import React, { useContext, Fragment } from 'react';
import { Form, Formik } from 'formik';
import PropTypes from 'prop-types';

import { Label, Row } from 'components/form/generic';
import { context as localeContext } from 'context/locale';
import { Field, Text } from 'components/service';
import { Input } from 'components/form/elements';
import { context } from '../context';
import convertMultiLanguagesFromObjectToArray from '../../../../../utils';

const FirstStep = ({ courierIntegrationInfo, courierDynamicSection, setAjwanValues }) => {
  const { lang } = useContext(localeContext);
  const { ajwanValues } = useContext(context);
  const handleSubmitValue = (key, value) => {
    setAjwanValues(prevState => ({
      ...prevState,
      [key]: value,
    }));
  };
  return (
    <div className="px-4 whitespace-pre-wrap leading-relaxed">
      {courierIntegrationInfo?.length &&
        courierIntegrationInfo.map(info => (
          <Fragment key={`text${info.header?.en}`}>
            <Text className="font-bold mb-3" value={convertMultiLanguagesFromObjectToArray(info.header)} />
            <Text className="mb-4" value={convertMultiLanguagesFromObjectToArray(info.body)} />
          </Fragment>
        ))}
      {courierDynamicSection?.length &&
        courierDynamicSection.map(courierSection => {
          const {
            title,
            inputField: { backendName, hintAr, hintEn, type },
          } = courierSection;

          const initialValues = { [backendName]: ajwanValues[backendName] };
          return (
            <Formik initialValues={initialValues}>
              <Form>
                <Row className="py-2">
                  <Label title={<Text value={[title.en, title.ar]} />}>
                    <Field
                      name={`${backendName}`}
                      type={type}
                      component={Input}
                      placeholder={lang === 'en' ? hintEn : hintAr}
                      onChange={e => handleSubmitValue(backendName, e.target.value)}
                    />
                  </Label>
                </Row>
              </Form>
            </Formik>
          );
        })}
    </div>
  );
};

FirstStep.propTypes = {
  courierDynamicSection: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.shape({
        ar: PropTypes.string.isRequired,
        en: PropTypes.string.isRequired,
      }),
      inputField: PropTypes.shape({
        backendName: PropTypes.string.isRequired,
        hintAr: PropTypes.string.isRequired,
        hintEn: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
      }),
    }),
  ),
  courierIntegrationInfo: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.shape({
        ar: PropTypes.string.isRequired,
        en: PropTypes.string.isRequired,
      }),
      body: PropTypes.shape({
        ar: PropTypes.string.isRequired,
        en: PropTypes.string.isRequired,
      }),
    }),
  ),
  setAjwanValues: PropTypes.func.isRequired,
};
export default FirstStep;
